<template>
  <div id="home">
      <ui-header :nav-num="-1" :user-info="userInfo" :nav="nav" :login-url="loginUrl" :logout-url="logoutUrl" :home-url="homeUrl" :register-url="registerUrl" :ucenter-url="ucenterUrl"></ui-header>
      <div class="main">
          <div class="go-back">
              <p class="go-back-title">该网址不存在，去首页看看吧</p>
              <a class="go-back-btn" :href="homeUrl">返回首页</a>
          </div>
          <img class="not-found-img" :src="notFound" />
      </div>
  </div>
</template>
<script>
import UiHeader from 'uiHeader'
import NoFoundImg from '../../static/img/404/404.png'
export default {
    components:{
        UiHeader
    },
    data: function() {
        return {
            notFound: NoFoundImg,
            homeUrl: window.PAGE_DATA.webSite.homeUrl || '',
            userInfo:window.PAGE_DATA.commonData.userInfo || {},
            nav:      window.PAGE_DATA.commonData.nav       || [],
            loginUrl: window.PAGE_DATA.commonData.loginUrl || '',
            logoutUrl: window.PAGE_DATA.commonData.logoutUrl || '',
            registerUrl: window.PAGE_DATA.commonData.registerUrl || '',
            ucenterUrl: window.PAGE_DATA.commonData.ucenterUrl || ''
        }
    }
}
</script>
<style lang="scss" scoped>
    #home{
        background-color: #fff;
        .main{
            width:100%;
            margin: 0 auto;
            padding-top: 5%;

            .go-back{
                text-align: center;
                .go-back-title{
                    font-size: 16px;
                    color: #999;
                }
                .go-back-btn{
                    width: 260px;
                    height: 50px;
                    border-radius: 4px;
                    background-color: #364983;
                    color: #fff;
                    font-size: 16px;
                    line-height: 50px;
                    display: inline-block;
                    margin-top: 28px;
                }
            }
            .not-found-img{
                width: 80%;
                margin-left: 10%;
                margin-right: 10%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/notFound/Home.vue